import React, { useMemo } from 'react';
import { useZunelo } from '../../context/ZuneloContext';
import { GMAIL_AXES, sortRecentAttentionItems } from '../../domain/filtering';
import { defaultAxisFilterState, filterByAxes } from '../../domain/multiAxisFiltering';
import { FilterButton } from '../../ui/common/FilterButton';
import { GmailCard } from './GmailCard';
import { SourceFeedState } from '../sources/SourceFeedState';
import { SourceGate } from '../sources/SourceGate';

export const GmailView: React.FC = () => {
  const {
    items,
    activeAxisFilters,
    setActiveAxisFilters,
    selectedId,
    loadingSources,
    errors,
    retry,
  } = useZunelo();

  const sourceItems = useMemo(
    () => sortRecentAttentionItems(items.filter((i) => i.source === 'gmail')),
    [items],
  );
  const currentFilters = activeAxisFilters['gmail'] || defaultAxisFilterState(GMAIL_AXES);
  const isLoading = loadingSources.gmail && sourceItems.length === 0;

  const filteredItems = useMemo(
    () => filterByAxes(sourceItems, GMAIL_AXES, currentFilters),
    [sourceItems, currentFilters],
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <SourceGate
        source="gmail"
        error={errors.gmail}
        isLoading={isLoading}
        totalCount={sourceItems.length}
        isRetrying={loadingSources.gmail}
        onRetry={() => retry('gmail')}
      >
        <FilterButton
          axes={GMAIL_AXES}
          items={sourceItems}
          value={currentFilters}
          onChange={(next) => setActiveAxisFilters('gmail', next)}
        />

        <SourceFeedState
          source="gmail"
          error={errors.gmail}
          isLoading={isLoading}
          isRetrying={loadingSources.gmail}
          onRetry={() => retry('gmail')}
          totalCount={sourceItems.length}
          visibleCount={filteredItems.length}
          onShowAll={() => setActiveAxisFilters('gmail', defaultAxisFilterState(GMAIL_AXES))}
        >
          {filteredItems.map((item) => (
            <GmailCard key={item.id} item={item} isSelected={selectedId === item.id} />
          ))}
        </SourceFeedState>
      </SourceGate>
    </div>
  );
};
